// oxlint-disable no-process-env
import { z } from 'zod'

import { createEnv } from '@isoapp/common/env/createEnv'

export const env = createEnv({
  client: {
    NEXT_PUBLIC_DISTRICT_ENV: z.literal(['development', 'staging', 'production']),
    NEXT_PUBLIC_DISTRICT_ENV_ALPHA: z.stringbool().default(false),
    NEXT_PUBLIC_DISTRICT_APP_NAME: z.literal([
      'auth',
      'builder',
      'checkout',
      'marketing',
      'modweb',
      'web',
      'shopify',
      'settings',
      'live',
    ]),
  },
  experimental__runtimeEnv: {
    NEXT_PUBLIC_DISTRICT_ENV: process.env.NEXT_PUBLIC_DISTRICT_ENV,
    NEXT_PUBLIC_DISTRICT_ENV_ALPHA: process.env.NEXT_PUBLIC_DISTRICT_ENV_ALPHA,
    NEXT_PUBLIC_DISTRICT_APP_NAME: process.env.NEXT_PUBLIC_DISTRICT_APP_NAME,
  },
})

// system vars available on client side even without NEXT_PUBLIC_ prefix
export const systemEnv = z
  .object({
    VERCEL_ENV: z.literal(['development', 'preview', 'production']).default('development'),
  })
  .parse({
    VERCEL_ENV: process.env.VERCEL_ENV,
  })

export const DISTRICT_ENV = env.NEXT_PUBLIC_DISTRICT_ENV
